
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import { iFile, createSize } from '@/common/utils'
import FilePlus from '@/common/class/FilePlus'
// @ts-ignore
import DefaultLogo from '@/assets/common_images/default_logo.png'

export interface AvatarUploadIns {
    getFile: () => File
}
const avatarSize = createSize({ size: 2, type: 'MB' })
const defaultFile = iFile.dataUrlToFile(DefaultLogo, 'default_logo')

/**
 * @prop src            头像地址
 * @prop action         是否显示操作按钮
 * @prop button-text    操作按钮文案
 * @emit change         图片发生改变
*/
@Component({
    name: 'avatar-upload'
})
export default class extends Vue {
    @Prop({ default: '' }) private src!: string
    @Prop({ default: '更换头像' }) private buttonText!: string
    @Prop({ default: true }) private action!: boolean
    @Ref('avatarInputRef') private avatarInputEl!: any
    private cAvatar = DefaultLogo
    private avatarUrl = ''
    private inputByUrl = false
    private avatarVisiable = false
    private imgFile: any = defaultFile

    private get companyAvatarBtn() {
        let classNames = ['company-avatar-buttons']
        if (this.inputByUrl) classNames.push('url')
        return classNames.join(' ')
    }
    private get avatarEl() {
        return document.getElementById('avatar') as HTMLElement
    }
    private get fileEl() {
        type FileInput = HTMLElement & { value: string }
        return document.getElementById('fileInput') as FileInput
    }
    @Watch('src')
    private watchSrc(val: string) {
        if (!val) return
        this.initAvatar(val)
    }

    mounted() {
        this.src && this.initAvatar(this.src)
    }
    initAvatar(val: string) {
        this.imgFile = ''
        this.cAvatar = val
    }
    onAvatarPopoverHide() {
        this.avatarUrl = ''
        this.inputByUrl = false
    }
    onInputUrl() {
        this.inputByUrl = true
        this.$nextTick(() => {
            this.avatarInputEl.$el.querySelector('input').focus()
        })
    }
    onAvatarInputEnter() {
        this.fileEl.value = ''
        this.cAvatar = this.avatarUrl
        this.avatarUrl = ''
        this.inputByUrl = false
        this.imgFile = ''
        this.avatarEl.click()
        this.$emit('change')
    }
    onAvatarReset() {
        this.fileEl.value = ''
        if (this.src) {
            // 重置有两种情况、当有 src 传入的情况下的
            this.imgFile = ''
            this.cAvatar = this.src
        } else {
            this.cAvatar = DefaultLogo
            this.imgFile = defaultFile
        }
        this.$emit('change')
    }
    // 图片文件改变
    onAvatarFileChange(event: any) {
        // @ts-ignore
        let file = event.target.files[0]
        let fp = new FilePlus(file, { type: 'image', size: avatarSize })
        if (fp.hasSizeError) {
            return this.$mwarning('选择的配图不能大于2MB')
        }
        if (file) {
            // 替换图片地址
            this.cAvatar = fp.getImageTempUrl()
            if (!this.cAvatar) {
                this.$merror('选择图片失败，请重试喔')
            } else {
                this.imgFile = file
                this.$emit('change')
            }
        }
    }
    // 暴露给外部
    getFile() {
        // 优先返回文件
        // 当输入网址、有 src 传入，imgFile 会被置空
        if (this.imgFile) {
            return this.imgFile === defaultFile ? '' : this.imgFile
        } else if (this.src) {
            const isEqual = this.src === this.cAvatar
            return isEqual ? this.src : this.cAvatar
        } else {
            // 无 src，并输入网址
            return this.cAvatar
        }
    }
    // 暴露给外部
    reset() {
        this.cAvatar = DefaultLogo
        this.imgFile = defaultFile
    }
}
